import { utils } from "../utils/utils";
import { HttpClient } from "./serviceBase";

class SettlementsService {
    Search = async (filters, config) => 
        await HttpClient.Get(`/api/settlements?${utils.GetQueryStringsFromObject(filters)}`, config);

    Create = async (request) => 
        await HttpClient.Post(`/api/settlements`, request);

    SearchTerminals = async (filters, config) => 
        await HttpClient.Get(`/api/settlements/terminals?${utils.GetQueryStringsFromObject(filters)}`, config);
}

export default new SettlementsService();